import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainRoutingModule } from './main-routing.module';
import { TableComponent } from './components/table/table.component';
import { HomeComponent } from './pages/home/home.component';
import { PrimeModule } from 'src/app/prime.module';

import { FormComponent } from './components/form/form.component';
import { CrmLeadsDashboardComponent } from './pages/crm-management/crm-leads-dashboard/crm-leads-dashboard.component';
import { CrmManagementComponent } from './pages/crm-management/crm-management.component';
import { CrmStatsComponent } from './pages/crm-management/crm-stats/crm-stats.component';
import { MainViewComponent } from './pages/main-view/main-view.component';
import { SettingsComponent } from './pages/settings/settings.component';

import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ShareModule } from 'src/app/_share/share.module';

import { SummaryComponent } from './components/summary/summary.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

// import { ServicesComponent } from '../network-portal/pages/services/services.component';
import { StatisticsSummaryComponent } from './components/statistics-summary/statistics-summary.component';
import { ViewDetailsComponent } from '../operations/components/view-details/view-details.component';
import { UserAccountProfileComponent } from './pages/home/user-account-profile/user-account-profile.component';

import { OrdersComponent } from '../network-portal/pages/orders/orders.component';
import { NetworkAlarmsComponent } from '../network-portal/components/network-alarms/network-alarms.component';

import { ProductsPromotionsComponent } from '../network-portal/components/products-promotions/products-promotions.component';
import { ServicesBillingComponent } from '../network-portal/pages/services-billing/services-billing.component';
import { ServicesCustomersComponent } from '../network-portal/pages/services-customers/services-customers.component';
import { ServicesChargesComponent } from '../network-portal/pages/services-charges/services-charges.component';
import { ServicesManagementComponent } from '../network-portal/pages/services-management/services-management.component';

import { DialogBillingRunComponent } from '../network-portal/components/dialog-billing-run/dialog-billing-run.component';
import { ServicesManagementActionsComponent } from '../network-portal/pages/services-management/services-management-actions/services-management-actions.component';

@NgModule({
  declarations: [
    TableComponent,
    HomeComponent,
    FormComponent,
    SettingsComponent,
    DashboardComponent,
    MainViewComponent,
    CrmManagementComponent,
    CrmLeadsDashboardComponent,
    CrmStatsComponent,
    SummaryComponent,

    StatisticsSummaryComponent,
    ViewDetailsComponent,
    UserAccountProfileComponent,
    OrdersComponent,
    NetworkAlarmsComponent,
    ProductsPromotionsComponent,
    ServicesBillingComponent,
    ServicesCustomersComponent,
    ServicesChargesComponent,
    ServicesManagementComponent,
    DialogBillingRunComponent,
    ServicesManagementActionsComponent
  ],
  imports: [
    CommonModule,

    MainRoutingModule,
    PrimeModule,
    HttpClientJsonpModule,
    HttpClientModule,

    ShareModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    TableComponent,
    HomeComponent,
    FormComponent,
    SettingsComponent,
    MainViewComponent,
    CrmManagementComponent,
    CrmLeadsDashboardComponent,
    CrmStatsComponent,
    SummaryComponent,

    StatisticsSummaryComponent,
    ViewDetailsComponent,
    UserAccountProfileComponent,
    OrdersComponent,
    NetworkAlarmsComponent,

    ProductsPromotionsComponent,
    ServicesBillingComponent,
    ServicesCustomersComponent,
    ServicesChargesComponent,
    ServicesManagementComponent,
    DialogBillingRunComponent,
    ServicesManagementActionsComponent
  ]
})
export class MainModule {}
